import request from '@/utils/request'

export function findProfileGoods(params) {
  return request({
    url: `/customer/profile_goods`,
    method: 'get',
    params
  })
}

export function findProfileGoodsInfo(id, params) {
  return request({
    url: `/customer/profile_goods/${id}`,
    method: 'get',
    params
  })
}
